import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-correct",
  "use": "icon-correct-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-correct\">\n    <path fill=\"#2CB61E\" fill-rule=\"evenodd\" d=\"M13.634 4.508c.39.39.39 1.023 0 1.414L7.27 12.286c-.055.055-.114.102-.178.142-.04.063-.087.123-.142.179-.39.39-1.024.39-1.414 0L2.707 9.778c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0l2.122 2.12 5.977-5.976c.39-.39 1.024-.39 1.414 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol